import type React from 'react';

import type { Body, Meta, Uppy } from '@uppy/core';

import { Button } from '@change/ds-core-ui/Button';

import { CustomFileInput } from './CustomFileInput';

type Props = {
	uppy: Uppy<Meta, Body>;
	fileInputId: string;
	inputDataQa?: string;
	onButtonClick?: () => void;
	uploadButtonText?: string;
};

export const AccessibleFileInputWrapper: React.FC<Props> = ({
	uppy,
	fileInputId,
	inputDataQa,
	onButtonClick,
	uploadButtonText = 'Upload',
}) => {
	/* FIXME we should not override the Button component => use buttonResetStyles instead */
	const buttonComponentOverrides = {
		as: 'label',
		htmlFor: fileInputId,
		role: '',
	} as unknown as EmptyProps;

	return (
		<>
			<CustomFileInput onButtonClick={onButtonClick} fileInputId={fileInputId} uppy={uppy} data-qa={inputDataQa} />
			<Button
				{...buttonComponentOverrides}
				variant="secondary"
				size="x-small"
				tabIndex={-1}
				aria-controls={fileInputId}
				className="image-uploader-upload-button"
			>
				{uploadButtonText}
			</Button>
		</>
	);
};
